(() => {
  const body = document.querySelector('[data-policies-body]');
  if (!body) return;

  // --- Two-column split on desktop ---------------------------------------
  // The body is a single flat rich-text stream. To break it into two columns
  // at a merchant-defined point, we find the element containing the marker
  // string and force it (or its first sibling after it) to start a new CSS
  // column. This keeps the DOM flat so the section dividers (`> h2`) and the
  // nav scroll-spy keep working.
  setupColumns(body);

  if (body.hasAttribute('data-policies-nav-init')) return;

  const navs = document.querySelectorAll('[data-policies-nav]');
  const headings = body.querySelectorAll('h2');
  if (!navs.length || !headings.length) return;

  body.setAttribute('data-policies-nav-init', '');

  // The policy body is a single rich-text metafield, so headings have no ids.
  // Assign stable ids and build a nav link per heading inside each nav.
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `policy-section-${index}`;
    navs.forEach((nav) => {
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.className = 'armada-legal-sidebar__link';
      link.textContent = heading.textContent;
      nav.appendChild(link);
    });
  });

  const allLinks = document.querySelectorAll('.armada-legal-sidebar__link');
  const linkMap = new Map();
  allLinks.forEach((link) => {
    const href = link.getAttribute('href');
    if (!linkMap.has(href)) linkMap.set(href, []);
    linkMap.get(href).push(link);
  });

  // AAS-5624: how far an anchor target has to clear the top of the viewport to
  // land below the sticky header — the USP bar plus the header row — instead of
  // the hardcoded 80px that counted neither. Same source as smooth-scroll-nav.js;
  // StickyHeader has written the measured px value long before a link is clicked.
  const headerOffset = () => {
    const rootStyles = getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(rootStyles.getPropertyValue('--header-height')) || 80;
    const scrollSpacing = parseFloat(rootStyles.getPropertyValue('--space-5')) || 0;
    return headerHeight + scrollSpacing;
  };

  // Smooth scroll on click
  allLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const href = link.getAttribute('href');
      if (!href) return;
      const target = document.getElementById(href.slice(1));
      if (target) {
        const top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  // Scroll spy
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          allLinks.forEach((l) => l.classList.remove('armada-legal-sidebar__link--active'));
          const active = linkMap.get(`#${entry.target.id}`);
          if (active) active.forEach((l) => l.classList.add('armada-legal-sidebar__link--active'));
        }
      });
    },
    { rootMargin: '-10% 0px -60% 0px' }
  );

  headings.forEach((heading) => observer.observe(heading));

  function setupColumns(el) {
    if (el.hasAttribute('data-policies-columns-init')) return;
    const marker = (el.getAttribute('data-column-break') || '').trim();
    if (!marker) return;

    // Rich-text metafields render their content inside a
    // .metafield-rich_text_field wrapper, so the real flow container (the one
    // whose children we split into columns) is that wrapper when present.
    // Raw policy HTML from shop.policies has no wrapper, so fall back to el.
    const container = el.querySelector(':scope > .metafield-rich_text_field') || el;

    // Find the first top-level child whose text contains the marker. That
    // element starts the second column — its content is kept intact.
    const breakEl = Array.from(container.children).find(
      (child) => child.textContent && child.textContent.includes(marker)
    );
    if (!breakEl) return;

    breakEl.style.breakBefore = 'column';

    container.classList.add('armada-store-policies__body--columns');
    el.setAttribute('data-policies-columns-init', '');
  }
})();
